import { render } from "./OrderHistoryComponent.vue?vue&type=template&id=298a28f2&scoped=true"
import script from "./OrderHistoryComponent.vue?vue&type=script&lang=js"
export * from "./OrderHistoryComponent.vue?vue&type=script&lang=js"

import "./OrderHistoryComponent.vue?vue&type=style&index=0&id=298a28f2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298a28f2"],['__file',"resources/js/components/frontend/account/orderHistory/OrderHistoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "298a28f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('298a28f2', __exports__)) {
    api.reload('298a28f2', __exports__)
  }
  
  module.hot.accept("./OrderHistoryComponent.vue?vue&type=template&id=298a28f2&scoped=true", () => {
    api.rerender('298a28f2', render)
  })

}


export default __exports__